module.exports = __webpack_public_path__ + "static/media/login-background1.8b4d20a8.svg";